import HorizontalTabs from '@anm/components/HorizontalTabs';
import * as semrush from '@anm/helpers/semrush';
import { useEffect, FC } from 'react';

import ManageTeamSection from '../../team/ManageTeamSection';
import UserProfile from '../../user/UserProfile';
import YoutubeWhitelist from '../../user/YoutubeWhitelist';

import { Wrapper } from './Wrapper';
import useMyAccountTabsManager from './hooks/useMyAccountTabsManager';
import useTabs from './hooks/useTabs';

export type AccountTab = 'manage-team' | 'youtube-whitelist' | 'profile';

export const PROFILE_TAB = 0;
export const YOUTUBE_WHITELIST_TAB = 1;
export const MANAGE_TEAM_TAB = 2;

const isSemrush = semrush.isSemrushIframe();

type MyAccountSectionProps = {
  currentTab?: AccountTab;
};

const MyAccountSection: FC<MyAccountSectionProps> = ({ currentTab }) => {
  const [defaultTab, handleTabChange] = useMyAccountTabsManager(isSemrush ? 'youtube-whitelist' : currentTab);
  const { tabsNames } = useTabs();

  useEffect(() => {
    if (isSemrush) handleTabChange(1);
  }, [isSemrush]);

  return (
    <Wrapper>
      <HorizontalTabs {...{ defaultTab }} tabs={tabsNames} onTabChange={handleTabChange}>
        <UserProfile title={null} />
        <YoutubeWhitelist title={null} />
        <ManageTeamSection />
      </HorizontalTabs>
    </Wrapper>
  );
};

export default MyAccountSection;
